import { Badge, Card, CardActionArea, CardContent, Chip, Stack, Typography, Tooltip, Avatar } from "@mui/material";
import { Star as StarIcon, Receipt as ReceiptIcon } from "@mui/icons-material";

const currencyRD = (v) =>
  new Intl.NumberFormat("es-DO", { style: "currency", currency: "DOP" }).format(v);

const KIND_META = {
    product: {
      icon: <ReceiptIcon color="disabled" />,
      label: "Producto",
    },
    service: {
      icon: <ReceiptIcon color="disabled" />,
      label: "Servicio",
    },
  };            

export default function ProductCard({ item, onAdd, selected, qty=0, pagado=false }) {
    const meta = KIND_META[item.kind];
    return (
      <Badge
        invisible={true}
        overlap="circular"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        badgeContent={
            qty
          }
  
        sx={{
        width: "100%",
        "& .MuiBadge-badge": (theme) => ({
          // Position so it looks attached to the border
          top: 5,
          minWidth: 24,
          height: 24,
          borderRadius: "50%",
          fontWeight: 700,
          lineHeight: "24px",
          boxShadow: theme.shadows[1],
          backgroundColor: theme.palette.background.paper,
          color: theme.palette.text.primary,
          border: `2px solid ${
            selected ? theme.palette.primary.main : theme.palette.divider
          }`,
        }),
      }}
      >
        <Card
          variant="outlined"
          sx={{
            minWidth: 190,
            minHeight: 210,
            maxWidth: 190,
            maxHeight: 210,
            borderRadius: 3,
            // 👇 selected border & subtle lift
            borderColor: selected ? "primary.main" : "divider",
            borderWidth: selected ? 2 : 1,
            boxShadow: selected ? 3 : 0,
            "&:hover": {
            boxShadow: 3,
            borderColor: selected ? "primary.dark" : "primary.light",
            },
            transition: "box-shadow .2s, border-color .2s, border-width .2s",
          }}
        >
          <CardActionArea onClick={() => onAdd(item)} >
            <CardContent sx={{ minHeight: 150, display: "grid", placeItems: "center" }}>
              <Avatar sx={{ width: 56, height: 56, bgcolor: "grey.100" }}>
                <ReceiptIcon color="disabled" />
              </Avatar>
  
              <Stack spacing={1} alignItems="center" mt={1}>
                <Chip size="small" color={pagado ? "success" : "error"} variant="outlined" label={`${pagado ? "Pagado" : "Pendiente"}`} />
                <Typography variant="subtitle1" sx={{ fontWeight: 600, textAlign: "center" }}>
                  {item.nombre}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {currencyRD(item.montoFijo)}
                </Typography>
              </Stack>
            </CardContent>
          </CardActionArea>
        </Card>
      </Badge>
    );
  }
  